module.exports = __webpack_public_path__ + "static/media/Netflix-TheChefShow.12df8e92.jpg";